import { create } from "zustand";

export interface DriverItem {
  driverID: string;
  driverNumber: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email?: string;
  userId?: string;
  residentialAddress?: string;
  licenseCode: string;
  gender: string;
  assignedVehicleNumber: string;
  assignedVehicleType: string;
  driverStatus: string;
  hasPdp: boolean;
  workShift: string;
  branchId?: string;
  branchName?: string;
  branchLocation?: string;
  licenseIssueDate: string;
  licenseExpiryDate: string;
  currentCaseNumber?: string;
  currentAllocationNumber?: string;
  currentAllocationStatus?: string;
  currentBodyRemovalNumber?: string;
  currentBodyRemovalStatus?: string;

  documents: {
  document_id: string;
  document_type: string;
  file_url: string;
  file_name: string;
}[];
}

interface DriverState {
  driver: DriverItem[];
  totalElements: number;
  statusCounts: Record<string, number>;
  selectedDriver: DriverItem | null;

  setDriver: (data: any) => void;
  setSelectedDriver: (item: DriverItem) => void;
  clearSelectedDriver: () => void;
}

export const useDriverStore = create<DriverState>((set) => ({
  driver: [],
  totalElements: 0,
  statusCounts: {},
  selectedDriver: null,

  setDriver: (data) =>
    set({
      driver: data?.driver || [],
      totalElements: data?.totalCount || 0,
      statusCounts: data?.statusCounts || {},
    }),

  setSelectedDriver: (item) =>
    set({
      selectedDriver: item,
    }),

  clearSelectedDriver: () =>
    set({
      selectedDriver: null,
    }),
}));
